import React from 'react';
import { CameraIcon as HeroCameraIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type CameraIconProps = Omit<IconProps, 'children'>;

export const CameraIcon: React.FC<CameraIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroCameraIcon />
        </Icon>
    );
};
